import React from 'react'

export const MiniNav = () => {
  return (
    <div className="miniNav">
        <div className="cont-det"><a className='mr-3' href="tel:+61486034673"><i className="fa fa-mobile" aria-hidden="true"></i>+61 4860 34673</a> <a href="mailto:contact@dappomatics.com"><i className="fa fa-envelope" aria-hidden="true"></i>contact@dappomatics.com</a></div>
        <div className="loc">
            <p className=""><i className ="fas fa-map-marker-alt"></i> Our Global Offices : Germany | Australia </p>
        </div>
    </div>
  )
}
